import { useEffect, useState } from 'react';
import AlertItem from '@/components/AlertItem';
import Modal from '@/components/Modal';

export default function Alerts({ alerts }) {
  const [isAlertDrawerOpen, setIsAlertDrawerOpen] = useState(false);

  const moreAlerts = alerts.length > 1;
  const moreAlertsLength = alerts.length - 1;

  useEffect(() => {
    if (isAlertDrawerOpen) {
      const overlayDiv = document.createElement('div');
      overlayDiv.id = 'alert-overlay';
      overlayDiv.style.position = 'fixed';
      overlayDiv.style.top = 0;
      overlayDiv.style.left = 0;
      overlayDiv.style.width = '100%';
      overlayDiv.style.height = '100%';
      overlayDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
      overlayDiv.style.zIndex = 8;

      document.body.appendChild(overlayDiv);
    } else {
      const overlayDiv = document.getElementById('alert-overlay');
      if (overlayDiv) {
        document.body.removeChild(overlayDiv);
      }
    }

    // Cleanup function to remove the overlay if the component unmounts or if the drawer is closed
    return () => {
      const overlayDiv = document.getElementById('alert-overlay');
      if (overlayDiv) {
        document.body.removeChild(overlayDiv);
      }
    };
  }, [isAlertDrawerOpen]);

  // Sort alerts by priority: Park Closure first, then Danger, then others
  const categoryPriority = {
    'park closure': 0,
    danger: 1,
    caution: 2,
    information: 3,
  };

  alerts.sort((a, b) => {
    const priorityA = categoryPriority[a.category?.toLowerCase()] ?? 4;
    const priorityB = categoryPriority[b.category?.toLowerCase()] ?? 4;
    return priorityA - priorityB;
  });
  return (
    <div
      className={`w-full py-4 pb-3 absolute backdrop-blur bg-gradient-to-b from-beige-200/[0.9] to-beige-200/[0.6]`}
    >
      <div className={`max-w-8xl mx-auto px-4 sm:px-6 md:px-8`}>
        <AlertItem alert={alerts[0]} />
        {moreAlerts ? (
          <button
            className={`text-xs transition-transform pt-3`}
            onClick={() => setIsAlertDrawerOpen(!isAlertDrawerOpen)}
          >
            {isAlertDrawerOpen ? (
              '- Close alerts'
            ) : (
              <>
                + {moreAlertsLength} more{' '}
                {moreAlertsLength === 1 ? 'alert' : 'alerts'}
              </>
            )}
          </button>
        ) : null}
        <Modal
          isOpen={isAlertDrawerOpen}
          setIsOpen={setIsAlertDrawerOpen}
          title="More alerts"
          content={alerts.map((alert) => (
            <AlertItem key={alert.id} alert={alert} className={`mt-3`} />
          ))}
        />
      </div>
    </div>
  );
}
